import React from "react"
import Styles from "./style.module.sass"

const CategoryCirceBox = ({ category, onClick }) => {

  const handleClick = (e) => {
    onClick(category.id)
  }

  return <div onClick={handleClick}
              className={`${Styles.container} ${ category.selected && Styles.selected}`}>
    <div className={Styles.imageContainer}>
      <img src={category.app_image_url} alt={category.name} />
    </div>
    <div className={Styles.name}>{category.name}</div>
  </div>
}

export default CategoryCirceBox;
